import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import { openApp } from 'lib/helpers'

import { setSuggestToOpenAppActive } from 'store/actions/uiState'
import { selectIsSuggestLoginPopupActive } from 'store/selectors'

import Button from 'components/Button'

import './style.scss'

const SuggestOpenAppPopup = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const isActive = useSelector(selectIsSuggestLoginPopupActive)

  const onClose = () => {
    dispatch(setSuggestToOpenAppActive(false))
  }

  if (isActive) {
    return (
      <div className="SuggestOpenAppPopup">
        <div className="SuggestOpenAppPopup__overlay" onClick={onClose} />
        <div className="SuggestOpenAppPopup__box">
          <h2 className="SuggestOpenAppPopup__title">
            {t('suggest_open_app_popup.title')}
          </h2>
          <div
            className="SuggestOpenAppPopup__sub_title"
            dangerouslySetInnerHTML={{
              __html: t('suggest_open_app_popup.sub_title'),
            }}
          />
          <Button
            className="SuggestOpenAppPopup__button"
            onClick={() => openApp()}
            fluid
          >
            {t('suggest_open_app_popup.open_app_button')}
          </Button>
          <div
            className="SuggestOpenAppPopup__continue_on_web"
            role="link"
            onClick={onClose}
          >
            {t('suggest_open_app_popup.continue_on_web')}
          </div>
        </div>
      </div>
    )
  }

  return null
}

export default SuggestOpenAppPopup
